// @flow
import axios from 'axios';
import { call, put, select } from 'redux-saga/effects';

import { newTrial } from '../../actions/account/licence';
import { fetchOrganizations, fetchUserInfos, newOrganization } from '../../actions/account/user';
import firebase, { restName } from '../../firebase';
import { WholeState } from '../../reducers';
import { organizations as saasOrganizations } from '../../services/api/saas';
import { organizations as avaOrganizations } from '../../services/api/ava';

const getToken = (state: WholeState) => state.account.session.token;

// $FlowFixMe
export function* postOrganization({ payload }: Object) {
  try {
    const res = yield call(saasOrganizations.createOrganization, { ...payload });

    yield put(fetchUserInfos.request());
    yield put(newTrial.request(res.data.organization));
    yield put(newOrganization.success(res.data));
  } catch (err) {
    yield put(newOrganization.failure(err.response));
  }
}

// $FlowFixMe
export function* searchOrganizations({ orgName, orgType }: Object) {
  try {
    const firebaseUser = firebase.auth().currentUser;
    if (!firebaseUser) {
      return;
    }

    const data = {
      firebaseAuthUID: firebaseUser.uid,
      orgName,
      orgType,
    };
    const res = yield call(avaOrganizations.findOrganizations, data);
    yield put(fetchOrganizations.success(res.data));
  } catch (err) {
    yield put(fetchOrganizations.failure(err.response));
  }
}
